module.exports = "/components/components/displayAlerts-689219.html";